<div class="unsichtbar">{{'common.components.selectManyPicklist.selected' | hisUi}}:</div>
<ng-container class="selectedOptionsList">
@if (hasSelectedOptions()) {
    <p-dataView #content [ngModel]="" [hisDdKey]="hisDdKey()"
        [value]="selectedOptions()" styleClass="selectedDataContainer" [emptyMessage]="'&nbsp;'"
        [disabled]="disabled()">
        <ng-template #list>
            <div class="p-grid p-grid-nogutter">
                <ul>
                    @for (selectedOption of selectedOptions() || []; track selectedOption; let index = $index) {
                        @if (!maxDisplayedSelections() || showAllSelectedOptions() || index < maxDisplayedSelections() - 1 || maxDisplayedSelections() >= selectedOptions().length) {
                            <li class="selectedDataRow">
                                {{labelFor(selectedOption)}}
                                <button type="submit"
                                    (click)="removeOption(index)"
                                    hisImage="PANEL_CLOSE"
                                    class="icon deleteSelectedOption"
                                    [title]="'common.removeAssignmentOf' | hisUi: labelFor(selectedOption)"
                                    [disabled]="disabled()">
                                </button>
                            </li>
                        }
                    }

                    @if (maxDisplayedSelections() && maxDisplayedSelections() < selectedOptions().length) {
                        @if (!showAllSelectedOptions()) {
                            <li class="selectedDataRow">
                                <button type="submit"
                                    (click)="$event.stopPropagation(); toggleShowAll(); $event.preventDefault();"
                                    class="transparent showAllSelectedOptionsButton"
                                    [title]="'common.components.selectManyPicklist.showAllSelected' | hisUi"
                                    [disabled]="disabled()">
                                    <span class="btnText">... {{selectedOptions().length - maxDisplayedSelections() + 1}} {{'common.components.selectManyPicklist.more' | hisUi}}</span>
                                    <img hisImage="ARROW_OUT"
                                        class="inlineicon"
                                        [title]="'common.components.selectManyPicklist.showAllSelected'| hisUi">
                                </button>
                            </li>
                        }

                        @if (showAllSelectedOptions()) {
                            <li class="selectedDataRow">
                                <button type="submit"
                                    (click)="$event.stopPropagation(); toggleShowAll(); $event.preventDefault();"
                                    class="transparent showAllSelectedOptionsButton"
                                    [title]="'common.components.selectManyPicklist.showLess' | hisUi"
                                    [disabled]="disabled()">
                                    <span class="btnText">{{'common.components.selectManyPicklist.showLess' | hisUi}}</span>
                                    <img hisImage="ARROW_IN"
                                        class="inlineicon"
                                        [title]="'common.components.selectManyPicklist.showLess'| hisUi">
                                </button>
                            </li>
                        }
                    }
                </ul>
            </div>
        </ng-template>
    </p-dataView>
}
</ng-container>